import { DISLOYALTY_PROMOTIONAL_TARGET_RATES } from '@/booking/components/disloyalty-promotional-rate/constants';

export const getDisloyaltyTargetRate = (rateCode: string) =>
  Object.values(DISLOYALTY_PROMOTIONAL_TARGET_RATES).find(
    (targetRate) => rateCode === targetRate
  );
